import type { ReactNode } from "react";

/** 본문 제목 줄 , 제목, 한 줄 설명, 오른쪽 동작. 모든 목록,문서 화면이 같은 것을 쓴다 */
export function PageHeader({ title, description, actions }: { title: ReactNode; description?: ReactNode; actions?: ReactNode }) {
  return (
    <header className="page-header">
      <div className="min-w-0">
        <h1>{title}</h1>
        {description && <p className="page-header-desc">{description}</p>}
      </div>
      {actions && <div className="page-header-actions">{actions}</div>}
    </header>
  );
}
